import { useEffect, useState } from "react";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import CreateNewWorkOrderForm from "../../components/forms/workOrders/CreateNewWorkOrderForm";
import CustomerWorkOrdersTab from "../../components/forms/workOrders/CustomerWorkOrdersTab";
import WorkOrderDetailsModal from "../../components/forms/workOrders/WorkOrderDetailsModal";

import { useParams } from "react-router-dom";

import { WorkOrderDetailsViewModel } from "../../viewmodels/workOrders/WorkOrderDetailsViewModel";
import { classNames } from "primereact/utils";

const tabs = [
  { name: "Overview", href: "#" },
  { name: "History", href: "#" },
];

function WorkOrderDetails(props) {
  const { addSnackbar, logout } = props;

  const { id } = useParams();

  const {
    customers,
    getCustomersForDropdown,
    services,
    getServicesForDropdown,
    getWorkOrder,
    setEmptyModelOpen,
    emptyModal,
    showErrorModal,
    updateWorkOrderApiCall,
    workOrder,
    addServiceToOrderCall,
    askEditOrderItem,
    askDeleteOrderItem,
    printWorkOrder,
    previousWorkOrders,
    openAddNewMakeModal,
    getPreviousWorkOrders,
    removeImageAtIndexCall,
    uploadNewImageCall,
    updateMediaTitleCall,
    employeeOptions,
    getEmployeesForDropdown,
    onItemEditComplete,
    emailInvoice,
    emailWoInProgress,
  } = WorkOrderDetailsViewModel(logout, addSnackbar);

  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    getCustomersForDropdown();
    getServicesForDropdown();
    getEmployeesForDropdown();

    getWorkOrder(id);
  }, []);

  const renderComponent = (index) => {
    switch (index) {
      case 0:
        return (
          <div key={0}>
            <CreateNewWorkOrderForm
              customers={customers}
              isEdit={true}
              loading={false}
              showErrorModal={showErrorModal}
              workOrder={workOrder}
              services={services}
              actionCall={updateWorkOrderApiCall}
              setEmptyModelOpen={setEmptyModelOpen}
              addServiceToOrderCall={addServiceToOrderCall}
              askEditOrderItem={askEditOrderItem}
              askDeleteOrderItem={askDeleteOrderItem}
              printWorkOrder={printWorkOrder}
              openAddNewMakeModal={openAddNewMakeModal}
              removeImageAtIndexCall={removeImageAtIndexCall}
              uploadNewImageCall={uploadNewImageCall}
              updateMediaTitleCall={updateMediaTitleCall}
              onItemEditComplete={onItemEditComplete}
              employeeOptions={employeeOptions}
              emailInvoice={emailInvoice}
              emailWoInProgress={emailWoInProgress}
            />
          </div>
        );

      case 1:
        return (
          <div key={1} className="bg-white">
            <CustomerWorkOrdersTab
              workOrders={previousWorkOrders}
              getPreviousWorkOrders={getPreviousWorkOrders}
              openDetails={(workOrder) =>
                setEmptyModelOpen({
                  childComponent: (
                    <WorkOrderDetailsModal
                      workOrder={workOrder}
                      closeModal={() =>
                        setEmptyModelOpen({
                          open: false,
                        })
                      }
                    />
                  ),
                  open: true,
                })
              }
            />
          </div>
        );

      default:
        return (
          <div key={1000} className="bg-white">
            Could not load page, please try again
          </div>
        );
    }
  };

  return (
    <div>
      <div className="mt-2 px-2">
        <div className="sm:items-center">
          <div className="flex gap-4">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              Work order: {workOrder.work_number}
            </h1>
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              Customer: {workOrder.customer.label}
            </h1>
          </div>
          <div className="mt-5">
            {/* tab here */}
            <div className="hide-for-print">
              <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                  Select a tab
                </label>
                <select
                  id="tabs"
                  name="tabs"
                  className="block w-full border-gray-300 rounded-md"
                  defaultValue={tabs[currentTab].name}
                >
                  {tabs.map((tab, index) => (
                    <option key={index}>{tab.name}</option>
                  ))}
                </select>
              </div>
              <div className="hidden sm:block">
                <nav
                  className="relative z-0 rounded-lg shadow flex"
                  aria-label="Tabs"
                >
                  {tabs.map((tab, index) => (
                    <a
                      key={tab.name}
                      href={tab.href}
                      className={classNames(
                        index === currentTab
                          ? "text-gray-900"
                          : "text-gray-500 hover:text-gray-700",
                        index === 0 ? "rounded-l-lg" : "",
                        index === tabs.length - 1 ? "rounded-r-lg" : "",
                        "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                      )}
                      aria-current={index === currentTab ? "page" : undefined}
                      onClick={() => setCurrentTab(index)}
                    >
                      <span>{tab.name}</span>
                      <span
                        aria-hidden="true"
                        className={classNames(
                          index === currentTab
                            ? "bg-indigo-500"
                            : "bg-transparent",
                          "absolute inset-x-0 bottom-0 h-0.5"
                        )}
                      />
                    </a>
                  ))}
                </nav>
              </div>
            </div>

            {/* {tab content starts below} */}
            <div className="px-4 py-2 sm:px-0">
              <div className="sm:col-span-9">
                {tabs.map((item, index) =>
                  index === currentTab ? renderComponent(index) : null
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WorkOrderDetails)
);
